import { ChangeDetectionStrategy, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { isIFrameSameOrigin } from '../../shared/helpers/is-same-origin';
import { OeAppPersonService } from '../../shared/oe-app-person.service';
import { OeAppService } from '../../shared/oe-app.service';
import { IFrameSizeEventType } from '../../shared/types/iframe-event-type';
import { LpConstants } from '../../shared/types/lp-constants';

const OFFSET_HEIGHT = 68;

@Component({
  selector: 'lp2-mid-level-exam-page',
  templateUrl: './mid-level-exam-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,

})
export class MidLevelExamPageComponent implements OnInit, OnDestroy {
  @ViewChild('iframe') iframe: ElementRef<HTMLIFrameElement>;
  midLevelExamUrl: string;
  lp2LearnosityUiHost: string;

  constructor(private oeApp: OeAppService,
    private oeAppPersonService: OeAppPersonService) { }

  ngOnInit() {
    window.addEventListener('message', this.handleEvents.bind(this), false);
    const preferredLanguageIsoCode = this.oeAppPersonService.preferredLang;
    const successUrl = window.location.origin + LpConstants.STUDY_BUNDLE_URL;
    const { levelId, levelNum } = this.getParamsFromUrl();
    this.midLevelExamUrl =
    this.oeApp.lp2LearnosityUiHost + '/mid-level-exam' +
      '?lang=' + preferredLanguageIsoCode +
      '&successUrl=' + successUrl +
      '&levelId=' + levelId +
      '&levelNum=' + levelNum;
  }

  getParamsFromUrl() {
    const url = new URL(window.location.href);
    const urlParams = new URLSearchParams(url.search);
    const levelId = urlParams.get('levelId');
    const levelNum = urlParams.get('levelId').toString().split('').reduce(this.reducer, 0);
    return { levelId, levelNum };
  }

  private reducer(previous, current) {
    return Number(previous) + Number(current);
  } 

  private handleEvents({ data, origin }) {
    if (isIFrameSameOrigin(window.location.href, origin)) {
      return;
    }

    if (data.type === IFrameSizeEventType.HEIGHT) {
      this.iframe.nativeElement.height = data.height + OFFSET_HEIGHT;
    }
  }

  ngOnDestroy() {
    window.removeEventListener('message', this.handleEvents);
  }
}



// WEBPACK FOOTER //
// ./ts/app/mid-level-exam/mid-level-exam-page/mid-level-exam-page.component.ts